import { css as cn } from '@emotion/css';

export const disableChildPointerEventsClass = cn`
  & * {
    pointer-events: none;
  }
`;
